import { render, staticRenderFns } from "./TableOfContents.vue?vue&type=template&id=dbdd0076&scoped=true"
import script from "./TableOfContents.vue?vue&type=script&lang=js"
export * from "./TableOfContents.vue?vue&type=script&lang=js"
import style0 from "./TableOfContents.vue?vue&type=style&index=0&id=dbdd0076&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbdd0076",
  null
  
)

export default component.exports